import React from 'react';
import { ShieldCheck } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  icon?: boolean;
  href?: string;
  scrollTo?: string;
}
export function Button({
  children,
  className = '',
  icon = true,
  href = 'http://bettertodayhub.com/cart/51407200649506:1',
  scrollTo
}: ButtonProps) {
  if (scrollTo) {
    return <button onClick={() => document.getElementById(scrollTo)?.scrollIntoView({
      behavior: 'smooth'
    })} className={`btn-primary w-full md:w-auto ${className}`} data-id="element-45">
        {icon && <ShieldCheck className="w-6 h-6 mr-3" data-id="element-46" />}
        {children}
      </button>;
  }
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`btn-primary w-full md:w-auto ${className}`} data-id="element-47">
      {icon && <ShieldCheck className="w-6 h-6 mr-3" data-id="element-48" />}
      {children}
    </a>;
}